import { useStore } from '@/lib/store';
import { Button } from '@/components/ui/button';
import { EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function ImpersonationBanner() {
    const isSupportImpersonation = useStore(state => state.isSupportImpersonation);
    const stopImpersonation = useStore(state => state.stopImpersonation);
    const navigate = useNavigate();

    if (!isSupportImpersonation) return null;

    return (
        <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between shadow-md relative z-50">
            <div className="flex items-center gap-2 text-sm font-medium">
                <EyeOff className="w-4 h-4" />
                <span>Viewing as User (Read-Only Mode)</span>
            </div>
            <Button
                variant="secondary"
                size="sm"
                className="h-7 text-xs bg-white text-amber-600 hover:bg-white/90"
                onClick={async () => {
                    await stopImpersonation();
                    navigate('/settings');
                }}
            >
                Exit Impersonation
            </Button>
        </div>
    );
}
